<template>
    <div>
        <div class="netResource">
            <h3>网络资源</h3>
            <ul>
                <li v-for="(item,index) in dataList" :class="item.class">
                    <!--<i :style="{transform:'scaleY('+scaleY(item.value)+')'}"></i>-->
                    <i :style="{height:iconHeight(item.value)}"></i>
                    <span>{{item.value}}</span>
                    <h4>{{item.name}}</h4>
                </li>
            </ul>
        </div>
        <div class="innerManuscript">
            <h3>内部原创稿件</h3>
            <ul>
                <li v-for="item in innerDataList">
                    <i :class="['innerArticle', item.class]"></i>
                    <h4>{{item.type}}</h4>
                    <p>{{item.amount}}</p>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>
    export default {
        name: "netResource",
        data(){
            return {
                dataList:[
                    {
                        name:'纸媒',
                        value:350,
                        class:'paper'
                    },
                    {
                        name:'网站',
                        value:590,
                        class:'web'
                    },
                    {
                        name:'客户端',
                        value:434,
                        class:'client'
                    },
                    {
                        name:'微信',
                        value:328,
                        class:'weChat'
                    },
                    {
                        name:'其他',
                        value:358,
                        class:'other'
                    }
                ],
                innerDataList: [
                    {
                        type: '文字稿',
                        amount: 2988,
                        class: 'text'
                    },
                    {
                        type: '图集稿',
                        amount: 9898,
                        class: 'pic'
                    },
                    {
                        type: '视频稿',
                        amount: 2988,
                        class: 'video'
                    },
                ],
                dataListMax:0,
                timer: null
            }
        },
        computed:{
            iconHeight(){
                return function (value) {
                    let max = 0;
                    this.dataList.map(function (item,index) {
                        if (item.value > max){
                            max = item.value;
                        }
                    });
                    return Math.sqrt(value/max) * 110 + 'px'
                }
            }
        },
        mounted(){
            this.getDataList();
            this.timer =setInterval(() => {
                this.getDataList();
            }, 1000*60*15);
        },
        methods: {
            getDataList(){
                this.axios.get('/bigscreen/mediacaidata.json').then(res => {
                    if (res.data.data.caiCount && res.data.data.caiCount>0) {
                        this.dataList[0].value = res.data.data.netPaperCount;
                        this.dataList[1].value = res.data.data.netWebCount;
                        this.dataList[2].value = res.data.data.netAPPCount;
                        this.dataList[3].value = res.data.data.netWechatCount;
                        this.dataList[4].value = res.data.data.netWeiboCount + res.data.data.netNewmediaCount;
                        this.innerDataList[0].amount = res.data.data.textCount;
                        this.innerDataList[1].amount = res.data.data.imgCount;
                        this.innerDataList[2].amount = res.data.data.videoCount;
                        // this.innerDataList[3].amount = res.data.data.linkCount;
                    }
                })
            },
        },
        beforeDestroy(){
            clearInterval(this.timer);
        },
    }
</script>

<style scoped>
    .netResource{
        height: 400px;
        box-sizing: border-box;
        padding-left: 190px;
    }
    .netResource h3{
        font-size: 30px;
        color: #fff;
        display: flex;
        align-items: center;
        height: 30px;
        line-height: 30px;
    }
    .netResource h3:before{
        content: '';
        display: block;
        width: 12px;
        height: 12px;
        background: #4afffd;
        margin-right: 20px;
    }
    .netResource ul{
        height: calc( 100% - 30px);
        background: url("../../../assets/images/intent_in_bg.png") center center no-repeat;
        display: flex;
        justify-content: center;
    }
    .netResource ul li{
        height: 100%;
        display: flex;
        flex-flow: column;
        padding-top: 220px;
        align-items: center;
        box-sizing: border-box;
        position: relative;
    }
    .netResource ul li:before{
        position: absolute;
        content: '';
        display: block;
        width: 0px;
        height: 23%;
        top: 130px;
        left: 50%;
        border-left: 2px dashed #fff;
    }
    .netResource span{
        color: #4afffd;
        font-size: 30px;
    }
    .netResource h4{
        color: #fff;
        margin-top: 40px;
        font-size: 30px;
    }
    .netResource ul li{
        margin: 0 12px;
    }
    .netResource ul li i{
        width: 78px;
        height: 110px;
        position: absolute;
        bottom: 240px;
    }
    .netResource ul li.paper i{
        background: url("../../../assets/images/intent_in_1.png") center center no-repeat;
        background-size: 100% 100%;
        bottom: 210px;
    }
    .netResource ul li.paper{transform: translateY(-10px)}
    .netResource ul li.web i{
        background: url("../../../assets/images/intent_in_2.png") center center no-repeat;
        background-size: 100% 100%;
    }
    .netResource ul li.client i{
        background: url("../../../assets/images/intent_in_3.png") center center no-repeat;
        background-size: 100% 100%;
        bottom: 210px;
    }
    .netResource ul li.client{transform: translateY(5px)}
    .netResource ul li.weChat i{
        background: url("../../../assets/images/intent_in_4.png") center center no-repeat;
        background-size: 100% 100%;
    }
    .netResource ul li.other i{
        background: url("../../../assets/images/intent_in_5.png") center center no-repeat;
        background-size: 100% 100%;
        bottom: 200px;
    }
    .netResource ul li.other{transform: translateY(-10px)}
    /*内部原创*/
    .innerManuscript{
        color: #fff;
        margin-left: 22px;
        margin-top: 5px;
    }
    .innerManuscript h3{
        font-size: 28px;
        margin-bottom: 47px;
    }
    .innerManuscript ul li {
        position: relative;
    }
    .innerManuscript .innerArticle{
        width: 82px;
        height: 82px;
        margin-right: 24px;
    }
    .text{
        background: url("../../../assets/images/manuscript-word.png")center center no-repeat;
        background-size: 100% 100%;
    }
    .pic{
        background: url("../../../assets/images/manuscript-pic.png")center center no-repeat;
        background-size: 100% 100%;
    }
    .video{
        background: url("../../../assets/images/manuscript-video.png")center center no-repeat;
        background-size: 100% 100%;
    }
    .innerManuscript ul{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .innerManuscript ul li{
        height: 82px;
    }
    .innerManuscript ul li * {
        float: left;
    }
    .innerManuscript ul li h4, .innerManuscript ul li p{
        font-size: 27px;
        width: calc(100% - 106px);
    }
    .innerManuscript ul li p{
        color: #4afffd;
        margin-top: 14px;
    }
</style>
